<template>
  <div class="bookRoom">
    <div class="bookRoom-bg">
      <div class="block">
        <el-date-picker
          v-model="selectTime"
          type="daterange"
          @change="changeDate"
          :clearable="false"
          :range-separator="dateLength"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <div class="channel">
          <el-input v-model="channel" clearable :maxlength="20" placeholder="渠道码 Channel code" />
        </div>
        <el-button type="primary" class="book-in" @click="getListForC()">
          <img class="search" :src="search" alt="" />
        </el-button>
      </div>
    </div>
    <section class="container">
      <div class="bookRoomList" v-for="item in roomList" :key="item.id">
        <img class="goods_img" :src="item.coverImage" />
        <div class="goods_detail">
          <div class="detail_right">
            <div class="detail_title">
              <p>{{ item.name }}</p>
              <p>{{ item.nameEn }}</p>
            </div>
            <div class="conference_entitle">
              <div class="conference_img" v-for="val in item.tags" :key="val.name">
                <span>{{ val.name }}</span>
                <span>{{ val.nameEn }}</span>
              </div>
            </div>
            <div class="spec">
              <div class="spec_item" v-for="(item, index) in item.specTypeList" :key="index">
                <div class="spec-discount-wrap">
                  <span style="margin-right:12px">{{ item.specName }} {{item.specNameEn}}</span>
                  <span style="margin-right:12px">￥{{ item.price }}</span>
                  <span v-if="item.marketPrice" class="spec-del">￥{{ item.marketPrice }}</span>
                  <div v-if="item.discount" @click="toShowDiscount(item)" class="spec-discount">
                    <span>早鸟优惠</span>
                    <div class="discount-arrow" />
                  </div>
                </div>
                <el-button type="primary" size="small" class="button_detail" @click="toDetails(item.id)">立即预订 Book in</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="roomList.length === 0" class="no-data">未找到符合您搜索条件的房间</div>
    </section>
    <DiscountDialog :visible.sync="discountShow" :discountData="disocuntData" />
  </div>
</template>

<script>
import DiscountDialog from "@/components/base/DiscountDialog.vue";

export default {
  name: "bookRoom",
  data() {
    return {
      imgSrc: require("@/assets/img/bg.png"),
      search: require("@/assets/img/ss@2x.png"),
      selectTime: [],
      roomList: [],
      dateLength: 0,
      tag: false,
      smokingEnums: {
        0: {
          name:"不禁烟",
          nameEn:"Smoking allowed"
        },
        1: {
          name:"部分禁烟",
          nameEn:"Partial smoking"
        },
        2: {
          name:"禁烟",
          nameEn:"No smoking"
        },
      },
      windowEnums: {
        0: {
          name:"无",
          nameEn:"Without windows"
        },
        1: {
          name:"有",
          nameEn:"Windows"
        },
        2: {
          name:"部分有",
          nameEn:"Partial with windows"
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      discountShow: false,
      disocuntData: {},
      // 渠道码
      channel: '',
    };
  },
  props: {},
  computed: {},
  components: {
    DiscountDialog
  },
  async mounted() {
    let time = this.$route.query;
    let changeTime = [];
    changeTime[0] = time.startTime;
    changeTime[1] = time.endTime;
    this.selectTime = changeTime;
    this.channel = time.channel;
    let timeLength = await this.getDateLength(time.startTime, time.endTime);
    this.dateLength = timeLength + "晚";
    this.getListForC(time.startTime, time.endTime);
  },
  methods: {
    toShowDiscount (item) {
      const { discount, hitPolicy, marketPrice } = item;
      this.disocuntData = {
        discount,
        hitPolicy,
        marketPrice
      }
      this.discountShow = !this.discountShow;
    },
    toDetails(id) {
      let start = this.tag ? this.formatDate(this.selectTime[0]) : this.selectTime[0];
      let end = this.tag ? this.formatDate(this.selectTime[1]) : this.selectTime[1];
      this.$router.push({
        path: "/home/room-detail",
        query: {
          startTime: start,
          endTime: end,
          id: id,
          channelCode: this.channel
        },
      });
    },
    async getListForC(startTime, endTime) {
      let start_t = startTime ? startTime : this.tag ? this.formatDate(this.selectTime[0]) : this.selectTime[0];
      let end_t = endTime ? endTime : this.tag ? this.formatDate(this.selectTime[1]) : this.selectTime[1];
      let channelReg = /^[a-zA-Z0-9]{6,20}$/;
      if (this.channel && !channelReg.test(this.channel)) {
        this.$message.error("请填写正确的渠道码");
        return;
      }
      const params = {
        parkSwitch: "",
        saleDateEnd: end_t,
        saleDateStart: start_t,
        smokingSwitch: "",
        windowSwitch: "",
        channelCode: this.channel
      };
      try {
        let { data } = await this.$api.getListForC(params);
        this.roomList = (data || []).map((item) => {
          item.iconType = "close";
          let tags = [];
          let names = ["personCount", "smokingSwitch", "parkSwitch", "space", "windowSwitch"];
          for (let t in item) {

            if (names.indexOf(t) != -1) {
              if (t == "personCount") {
                tags.push({
                  name:`${item[t]}人间`,
                  nameEn:`${item[t]}Capacity`
                });
              } else if (t == "smokingSwitch") {
                tags.push(this.smokingEnums[item[t]]);
              } else if (t == "parkSwitch") {
              } else if (t == "space") {
                tags.push({
                  name:`${item[t]}㎡`,
                  nameEn:`${item[t]}Size`
                });
              } else if (t == "windowSwitch") {
                let tag=JSON.parse(JSON.stringify(this.windowEnums[item[t]]))
                tag.name=tag.name+'窗'
                tags.push(tag);
              }
            }
          }
          item.tags = tags;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return `${year}-${month}-${day > 9 ? day : "0" + day}`;
    },
    async getDateLength(start, end) {
      return (new Date(end).getTime() - new Date(start).getTime()) / (3600 * 24 * 1000);
    },
    async changeDate(val) {
      this.tag = true;
      if (!val) {
        this.dateLength = 0;
      } else {
        let [start, end] = val;
        let timeLength = await this.getDateLength(start, end);
        this.dateLength = timeLength + "晚";
      }
    },
  },
};
</script>

<style lang="scss">
.bookRoom-bg {
  width: 100%;
  height: 300px;
  background: url("~@/assets/img/jfbg.png") 0 0 / 100% 100% no-repeat;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 110px;
  .block {
    display: flex;
    .channel {
      height: 80px;
      line-height: 1;
      background: #ffffff;
      font-size: 20px;
      color: #333333;
      border: none;
      position: relative;
      &::before {
        content: '|';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        line-height: 76px;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
      }
      .el-input__inner {
        height: 80px;
        font-size: 18px;
        font-weight: bold;
        border: none;
        padding-left: 30px;
        text-align: center;
        min-width: 60px;
      }
    }
    .book-in {
      width: 240px;
      height: 80px;
      background: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      .search {
        width: 34px;
        height: 37px;
      }
    }
  }
}
.no-data {
  margin-top: 150px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.bookRoomList {
  width: 1200px;
  height: 358px;
  margin: 40px 0;
  position: relative;
  .goods_img {
    width: 328px;
    height: 328px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .goods_detail {
    width: 1159px;
    height: 358px;
    background: #ffffff;
    box-shadow: 0px 6px 40px 0px rgba(204, 204, 204, 0.3);
    position: absolute;
    top: 0;
    right: 0;
    .detail_right {
      height: 328px;
      margin-left: 328px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-right: 40px;
      .detail_title {
        padding-bottom: 35px;
        border-bottom: 1px solid #f0f0f0;
        p {
          font-size: 18px;

          font-weight: 400;
          color: #333333;
          line-height: 28px;
        }
      }
      .conference_entitle {
        display: flex;
        flex-wrap: wrap;
        line-height: 20px;
        .conference_img {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -webkit-flex;
          flex-direction: column;
          -webkit-flex-direction: column;
          -ms-flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-right: 60px;
          img {
            width: 22px;
            height: 22px;
            margin-right: 20px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }
        }
      }
      .mobile {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mobile_left {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-right: 19px;
          }
          span {
            font-size: 14px;

            font-weight: 400;
            color: #333333;
          }
        }
        .detail {
          width: 152px;
          height: 40px;
          background: #333333;
          font-size: 14px;

          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  border: none;
  width: 500px;
  height: 80px;
}
.el-date-editor .el-range-separator {
  width: 80px;
  line-height: 72px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
}
.el-date-editor .el-range__icon,
.el-date-editor .el-range__close-icon {
  width: 50px;
  font-size: 28px;
  line-height: 72px;
}
.el-date-editor .el-range__close-icon {
  width: 0;
}

.el-date-editor .el-range-input {
  font-size: 18px;
  width: 160px;
  font-weight: bold;
  color: #333333;
}
.spec .spec_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.spec-discount-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .spec-del {
    font-size: 12px;
    font-weight: 400;
    color: #A7A8AA;
    line-height: 17px;
    margin-right: 12px;
    text-decoration: line-through;
  }
  .spec-discount {
    background: #FFF8F2;
    border-radius: 2px;
    padding: 1px 5px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E47C47;
    line-height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    .discount-arrow {
      width: 5px;
      height: 9px;
      background-size: 100% 100%;
      background-image: url('https://slhk-noggin.tos-cn-beijing.volces.com/slds-file/images/f5dd5b4cf2ec4de38cad9493482ae967.png');
      margin-left: 3px;
    }
  }
}

</style>
